/**
 * Axios global configuration
 * CSRFトークンの自動付与とセッション切れ検知を設定
 */

import axios from "axios";

import { handleUnauthorizedResponse } from "./interceptors";

/**
 * Axiosインターセプターの初期化
 * この関数はアプリケーション起動時に一度だけ呼び出す必要があります
 */
export function setupAxiosInterceptors(): void {
  // レスポンスインターセプター: セッション切れの一元検知
  // OpenAPIによるリクエストもaxiosを利用しているため対象
  axios.interceptors.response.use(
    (response) => handleUnauthorizedResponse(response),
    (error) => {
      // エラーレスポンスがある場合はセッション切れを検知
      if (error.response) {
        return handleUnauthorizedResponse(error.response);
      }
      // ネットワークエラーなどはそのまま伝播
      return Promise.reject(error);
    },
  );
}
